export default function emptyFunction() { /// /tslint:disable-line:no-empty

}
